<template>
  <!-- <ScreenAdapter>

  </ScreenAdapter> -->

  <div class="fff">
    <Aside></Aside>
    <Header />
    <div class="container">
      <!-- 浙江成就 -->
      <div class="expand-content" v-if="zjcjData && zjcjData.length > 0">
        <div class="content-header" ref="234">
          <div class="text">浙江成就</div>
        </div>
        <div class="content-box">
          <div class="expand-bg">
            <div class="expand-content">
              <div class="swiper-content">
                <swiper :options="expandSwiperOption">
                  <swiper-slide v-for="item in zjcjData" :key="item.id" :data-kcid="item.id" :data-kcName="item.name">
                    <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`" :key="item.id" :data-kcid="item.id" :data-kcName="item.name"></div>
                  </swiper-slide>
                </swiper>
                <div class="swiper-pagination expand"></div>
                <div class="swiper-button-next expand" v-text="'>'"></div>
                <div class="swiper-button-prev expand" v-text="'<'"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 浙江共产党人 -->
      <div class="accept-content bg" v-if="zjgcdrData&&zjgcdrData.length>0">
        <div class="content-header" ref="235">
          <div class="text">浙江共产党人</div>
        </div>
        <div class="content-box">
          <div class="item" @click="jumpDetail(item)" v-for="item,index in zjgcdrData" :key="index">
            <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>
      </div>
      <!-- 浙江党史故事 -->
      <div class="century-content" v-if="zjdsgsData&&zjdsgsData.length">
        <div class="content-header" ref="236">
          <div class="text">浙江党史故事</div>
        </div>
        <div class="content-box">
          <div class="big-cover" @click="jumpDetail(zjdsgsData[0])">
            <div class="c-img" :style="`background:url(${zjdsgsData[0].photo}) no-repeat center/cover;`">

            </div>
          </div>
          <div class="sub-cover">
            <div class="cover-item" v-for="item,index in zjdsgsData.slice(1,3)" :key="index" @click="jumpDetail(item)">
              <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 红船精神 -->
      <div class="value-content" v-if="hcjsData&&hcjsData.length>0">
        <div class="content-header" ref="237">
          <div class="text">红船精神</div>
        </div>
        <div class="content-box">
          <div class="content-item" v-for="(item,index) in hcjsData.slice(0,2)" :key="index" @click="jumpDetail(item)">
            <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
          <div class="flex-hide"></div>
        </div>
      </div>
      <!-- 浙江精神 -->
      <div class="thought-content" v-if="zjjsData&&zjjsData.length>0">
        <div class="content-header" ref="238">
          <div class="text">浙江精神</div>
        </div>
        <div class="content-box">
          <div class="thought-bg">
            <div class="thought-content">
              <div class="swiper-content">
                <swiper :options="thoughtSwiperOption">
                  <swiper-slide v-for="item in zjjsData" :key="item.id" :data-id="item.id">
                    <div class="c-img" :data-id="item.id" :style="`background: url('${item.photo}') no-repeat center/cover;`"></div>
                  </swiper-slide>
                </swiper>
                <div class="swiper-pagination thought"></div>

                <div class="swiper-button-next thought"></div>
                <div class="swiper-button-prev thought"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 八八战略 -->
      <div class="history-content" v-if="bbzlData&&bbzlData.length>0">
        <div class="content-header" ref="239">
          <div class="text">八八战略</div>
        </div>
        <div class="content-box">
          <div class="swiper">
            <swiper :options="swiperOption">
              <swiper-slide v-for="item,index in bbzlData" :key="index">
                <div class="cover" :style="`background:url(${item.photo}) no-repeat center/cover;`" @click="jumpDetail(item)"></div>
              </swiper-slide>
            </swiper>
            <template v-if="bbzlData&&bbzlData.length>3">
              <div class="b swiper-pagination" slot="pagination"></div>
              <div class="b swiper-button-next">
              </div>
              <div class="b swiper-button-prev">
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Custom/Party/Header"
import Footer from "@/components/Custom/Party/Footer"
// import ScreenAdapter from "@/components/ScreenAdapter"
import services from '@/config/services'
import utils from "../../../../config/utils"
import Aside from "../../../../components/Custom/Party/Aside.vue"
export default {
  data () {
    let that = this
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      expandSwiperOption: {
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 18000,
          disableOnInteraction: false
        },
        coverflowEffect: {
          rotate: 70,
          stretch: 200,
          depth: 480,
          modifier: 1,
          slideShadows: false,
        },
        preventClicksPropagation: false,
        navigation: {
          // 前进后退按钮 ,不同版本配置方式不同
          nextEl: `.swiper-button-next.expand`,
          prevEl: `.swiper-button-prev.expand`,
        },
        pagination: {
          el: `.swiper-pagination.expand`,
        },
        on: {
          click: function (v) {
            let id = v.target.getAttribute("data-kcid");
            if (id) {
              window.open(`/center/${that.school_code}/custom/party/detail?id=${id}&key=local`, "_blank")
            }

          },
        },
      },
      thoughtSwiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 0,
          stretch: 300,
          depth: 150,
          modifier: 1,
          slideShadows: false,
        },
        preventClicksPropagation: false,
        navigation: {
          // 前进后退按钮 ,不同版本配置方式不同
          nextEl: `.swiper-button-next.bzyq`,
          prevEl: `.swiper-button-prev.bzyq`,
        },
        pagination: {
          el: `.swiper-pagination.bzyq`,
        },
        on: {
          click: function (v) {
            let id = v.target.getAttribute("data-id");
            if (id) {
              window.open(`/center/${that.school_code}/custom/party/detail?id=${id}&key=local`, "_blank")
            }
          },
        },
      },
      swiperOption: {
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },
        dynamicBullets: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 41,
        pagination: {
          el: ".b.swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".b.swiper-button-next",
          prevEl: ".b.swiper-button-prev",
        },
        // loop: true,
      },
      zjcjData: [],
      zjgcdrData: [],
      zjdsgsData: [],
      hcjsData: [],
      zjjsData: [],
      bbzlData: [],
    }
  },
  async mounted () {
    await this.getListData()
    await this.jumpPosition()
  },
  methods: {
    // 跳转到课程详情
    jumpDetail (item, key) {
      window.open(`/center/${this.school_code}/custom/party/detail?id=${item.id}&key=local`, "_blank")
    },
    // 锚点定位
    jumpPosition () {
      let that = this
      let position = that.$route.query.id
      if (position) {
        that.$nextTick(() => {
          let topVal = this.$refs[position].getBoundingClientRect().top
          document.body.scrollTop = topVal - 100
        })
      }
    },

    async getListData () {
      await services.getCourseList({ page: 1, size: 100, category_id: "234", school_code: this.school_code }).then(res => {
        this.zjcjData = res.data.items
      })
      await services.getCourseList({ page: 1, size: 1, category_id: "235", school_code: this.school_code }).then(res => {
        this.zjgcdrData = res.data.items
      })
      await services.getCourseList({ page: 1, size: 3, category_id: "236", school_code: this.school_code }).then(res => {
        this.zjdsgsData = res.data.items
      })
      await services.getCourseList({ page: 1, size: 2, category_id: "237", school_code: this.school_code }).then(res => {
        this.hcjsData = res.data.items
      })
      await services.getCourseList({ page: 1, size: 100, category_id: "238", school_code: this.school_code }).then(res => {
        this.zjjsData = res.data.items
      })
      await services.getCourseList({ page: 1, size: 100, category_id: "239", school_code: this.school_code }).then(res => {
        this.bbzlData = res.data.items
      })
    }
  },
  components: {
    Header,
    Footer,
    Aside,
    // ScreenAdapter
  }
}
</script>

<style  lang="less" scoped>
* {
    font-family: Microsoft YaHei;
}
.container {
    width: 1200px;
    margin: 0 auto;
    .c-img {
        width: 100%;
        height: 100%;
        transition: all 0.7s;
    }
    .content-header {
        width: 100%;
        height: 25px;
        position: relative;
        z-index: 100;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url('../../../../assets/custom/party/index/list-title.png')
            no-repeat center / cover;
        .text {
            font-size: 42px;
            font-weight: bold;
            background: linear-gradient(180deg, #b70000 70%, #ffcba5 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
    .content-box {
        position: relative;
        z-index: 10;
    }
    .expand-content {
        .content-header {
            margin: 40px 0 0;
        }
        .content-box {
            .swiper-slide {
                width: 740px !important;
                height: 416px !important;
                .cover {
                    width: 100%;
                    height: 100%;
                }
            }

            ::v-deep .swiper-pagination {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                bottom: -32px;
                left: 50%;
                transform: translateX(-50%);
            }
            ::v-deep .swiper-pagination-bullet {
                width: 7px;
                height: 7px;
                background: #b61e2a;
                border: 1px solid #ffffff;
                opacity: 0.5;
                border-radius: 50%;
                display: block;
                transition: all 0.3s;
                margin-right: 4px;
            }

            ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
                width: 13px;
                height: 7px;
                background: #b61e2a;
                border: 1px solid #ffffff;
                border-radius: 3px;
                opacity: 1;
                margin-right: 7px;
            }
        }
    }
    .expand-bg {
        background-position: center;
        background-size: cover;
        padding: 48px 0 38px;
        .expand-content {
            width: 1200px;
            margin: 0 auto;
            .swiper-content {
                position: relative;
                width: 100%;
                height: 465px;
                display: flex;
                align-items: center;
                .swiper-container {
                    height: 100%;
                    .swiper-wrapper {
                        .swiper-slide {
                            width: 740px;
                            height: 416px;
                            background: #fff;
                            background-size: 100% auto;
                            background-position: center;
                            cursor: pointer;
                            overflow: hidden;
                            .c-img {
                                width: 100%;
                                height: 100%;
                                transition: all 0.7s;
                            }
                            &.swiper-slide-active {
                                -webkit-transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                -moz-transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                -o-transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                -ms-transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                border: 2px solid red;
                                &:hover {
                                    .c-img {
                                        transform: scale(1.2);
                                    }
                                }
                            }
                        }
                    }
                }
                /deep/ .swiper-pagination {
                    bottom: 10px;
                    width: 100%;
                    .swiper-pagination-bullet {
                        width: 10px;
                        height: 10px;
                        background: #cdb29f;
                        border-radius: 50%;
                        margin: 0 6px;
                    }
                    .swiper-pagination-bullet.swiper-pagination-bullet-active {
                        width: 10px;
                        height: 10px;
                        background: #dd3639;
                        border-radius: 50%;
                    }
                }
                .swiper-button-next,
                .swiper-button-prev {
                    flex-shrink: 0;
                    background-size: cover;
                    background: #000;
                    z-index: 100;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    cursor: pointer;
                    text-align: center;
                    line-height: 44px;
                    width: 42px;
                    height: 44px;
                    color: #ffffff;
                    font-size: 22px;
                    font-family: fangsong;
                    font-weight: bold;
                    justify-content: center;
                }
                .swiper-button-prev {
                    left: 200px;

                    background: rgba(0, 0, 0, 0.37);
                    border-radius: 22px 0px 0px 22px;
                }
                .swiper-button-next {
                    right: 200px;

                    background: rgba(0, 0, 0, 0.37);
                    border-radius: 0px 22px 22px 0px;
                }
            }
        }
    }
    .accept-content {
        position: relative;
        top: 35px;
        padding: 20px 0 0;
        &.bg::before {
            content: '';
            display: inline-block;
            position: absolute;
            width: 100vw;
            background: url('../../../../assets/hzvtc/list/footer-bg.png')
                no-repeat center/cover;
            height: 1340px;
            top: -38px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1;
        }
        .content-box {
            width: 100%;
            height: 730px;
            background: url('../../../../assets/hzvtc/list/vita-b-news.png')
                no-repeat center/cover;
            position: relative;
            margin-top: -24px;
            .item {
                cursor: pointer;
                width: 817px;
                height: 459px;
                box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                overflow: hidden;
                .c-img {
                    width: 100%;
                    height: 100%;
                    transition: all 0.7s;
                }
                &:hover {
                    .c-img {
                        transform: scale(1.2);
                    }
                }
            }
        }
        &.zdsx {
            &::before {
                content: '';
                display: inline-block;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: 135px;
                width: 100vw;
                height: 650px;
                background: url('../../../../assets/hzvtc/list/profession-bg-c.png')
                    no-repeat center/cover;
            }
            .content-header {
                margin: 20px 0 0;
            }
        }
        &.fzdygzxz {
            .content-header {
                &::before,
                &::after {
                    width: 350px;
                }
            }
        }
    }

    .century-content {
        .content-header {
            margin: 45px 0 35px;
        }
        .content-box {
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            .big-cover {
                width: 785px;
                height: 442px;
            }
            .big-cover,
            .sub-cover .cover-item {
                overflow: hidden;
                &:hover {
                    .c-img {
                        transform: scale(1.2);
                    }
                }
            }
            .sub-cover {
                flex: 1;
                margin-left: 43px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .cover-item {
                    width: 100%;
                    height: 208px;
                    cursor: pointer;
                }
            }
        }
    }
    .value-content {
        position: relative;
        padding: 74px 0 18px;
        background: #ffe093;
        height: 547px;
        z-index: 100;
        margin: 40px 0 0;
        .content-box {
            position: relative;
            z-index: 10;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }
        &::before {
            content: '';
            display: inline-block;
            width: 100vw;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            height: 100%;
            position: absolute;
            background: url('../../../../assets/hzvtc/list/feature-bg.png')
                no-repeat center/cover;
        }
        .content-header {
            margin-bottom: 62px;
            font-weight: bold;
            .text {
                color: #fedfa8;
                background: unset;
                -webkit-text-fill-color: unset;
            }
        }

        &::after {
            content: '';
            display: inline-block;
            width: 100%;
            height: 510px;
            position: absolute;
            top: 18px;
            background: url('../../../../assets/hzvtc/list/feature-list-bg.png')
                no-repeat center/cover;
        }
        .content-box {
            justify-content: space-between;
            padding: 0 40px;
            .content-item {
                width: 545px;
                height: 307px;
                cursor: pointer;
                overflow: hidden;
                &:hover {
                    .c-img {
                        transform: scale(1.2);
                    }
                }
            }
        }
    }
    .thought-content {
        position: relative;
        &::before {
            content: '';
            display: inline-block;
            width: 100vw;
            top: -380px;
            left: 50%;
            transform: translateX(-50%);
            height: 1322px;
            position: absolute;
            background: url('../../../../assets/hzvtc/list/value-t-bg.png')
                no-repeat center/cover;
        }
        .content-header {
            margin: 45px 0 30px;
        }
        .content-box {
            .swiper-slide {
                width: 740px !important;
                height: 416px !important;
                overflow: hidden;
                &:hover {
                    .cover,
                    .c-img {
                        transform: scale(1.2);
                    }
                }
                .cover,
                .c-img {
                    width: 100%;
                    height: 100%;
                    transition: all 0.7s;
                }
            }

            ::v-deep .swiper-pagination {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                bottom: -32px;
                left: 50%;
                transform: translateX(-50%);
            }
            ::v-deep .swiper-pagination-bullet {
                width: 7px;
                height: 7px;
                background: #b61e2a;
                border: 1px solid #ffffff;
                opacity: 0.5;
                border-radius: 50%;
                display: block;
                transition: all 0.3s;
                margin-right: 4px;
            }

            ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
                width: 13px;
                height: 7px;
                background: #b61e2a;
                border: 1px solid #ffffff;
                border-radius: 3px;
                opacity: 1;
                margin-right: 7px;
            }
        }
    }

    .history-content {
        margin: 43px 0 72px;
        .content-header {
            margin-bottom: 35px;
        }
        .content-box {
            .swiper {
                position: relative;
                .swiper-slide {
                    width: 380px;
                    height: 214px;
                    overflow: hidden;
                    &:hover {
                        .cover {
                            transform: scale(1.2);
                        }
                    }
                }
                .cover {
                    width: calc(100%);
                    height: 100%;
                    cursor: pointer;
                    transition: all 0.7s;
                }
                ::v-deep .swiper-pagination {
                    margin-top: 24px;
                    display: flex;
                    justify-content: center;
                }
                ::v-deep .swiper-pagination-bullet {
                    width: 10px;
                    height: 10px;
                    background: #cdb29f;
                    border-radius: 50%;
                    display: block;
                    cursor: pointer;
                    &:not(:last-child) {
                        margin-right: 15px;
                    }
                }
                ::v-deep
                    .swiper-pagination-bullet.swiper-pagination-bullet-active {
                    background: #dd3639;
                }
                ::v-deep .swiper-button-next,
                ::v-deep .swiper-button-prev {
                    width: 17px;
                    height: 32px;
                    cursor: pointer;
                    display: block;
                }
                ::v-deep .swiper-wrapper {
                    position: unset !important;
                }
                ::v-deep .swiper-button-prev {
                    background: url('../../../../assets/hzvtc/list/swiper-prev.png')
                        no-repeat center/cover;
                    position: absolute;
                    top: 41%;
                    left: -24px;
                }

                ::v-deep .swiper-button-next {
                    background: url('../../../../assets/hzvtc/list/swiper-next.png')
                        no-repeat center/cover;
                    position: absolute;
                    top: 41%;
                    right: -24px;
                }
            }
        }
    }
}

.fff {
    background: #fff;
}
</style>